enum WorldpayGiftCardType {
  Vantiv = 'vantiv',
  StoreCard = 'storeCard',
}

export { WorldpayGiftCardType };
